<template>
	<span>
		<!-- <sf-data-table :columns="dayCols" ref="resultList" :rows="resultList" /> -->
		<!--<tr v-if="this.resultList.userName == SUM"style="background: red !important;">
			... test
		</tr>-->
		<!-- class="table-responsive table-flush sf-datatable el-table--scrollable-y" -->
		<!-- <el-table
			ref="resultList"
			:data="resultList"
			height="100%"
			:stripe="true"
			:border="true"
			:row-class-name="tableRowClassName"
			class="table-responsive table-flush sf-datatable el-table--scrollable-y"
		>
			<el-table-column v-for="column in dayCols" :key="column.field" :width="column.width" :label="column.label" :prop="column.field" />
		</el-table> -->
		<sf-data-table
			paging
			:columns="dayCols"
			:rows="resultList"
			:pageUnit="groups.pageUnit"
			:excel="isButton_(scrId, 'EX')"
			:totalSize="groups.totalSize"
			:currentPage="groups.currentPage"
			:pageArray="screen.pageArray"
			@changedPage="changedPage"
		/>
	</span>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserAccess/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	data() {
		return { screen: {} };
	},
	components: {},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		tableRowClassName({ row, rowIndex }) {
			if (row.userName === 'SUM') {
				return 'highlight-row';
			}
			return '';
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			this.$emit('refresh', currentPageVal, pageUnitVal);
		}
	}
};
</script>

<style>
.el-table .highlight-row {
	background: oldlace !important;
}
</style>
